import React, { useState, useEffect } from "react";

// Estructura idéntica de secciones e ítems para emparejar el ID de pregunta con su criterio teórico
const COMPONENTES_AUDITORIA = [
  {
    nombre: "A. Bases y apertura de caja",
    items: [
      { n: 1, criterio: "La base de caja asignada a cada cajero está registrada y coincide con el valor físico entregado." },
      { n: 2, criterio: "La entrega de bases se realiza individualmente y queda identificada por cajero y turno." },
      { n: 3, criterio: "Se realiza el arqueo inicial y se conserva evidencia del valor de apertura." },
      { n: 4, criterio: "Los puntos de pago cuentan con datáfono, impresora, sistema POS e insumos requeridos para la operación." }
    ]
  },
  {
    nombre: "B. Arqueos y manejo de efectivo",
    items: [
      { n: 5, criterio: "El efectivo físico coincide con el valor esperado según sistema al momento del arqueo." },
      { n: 6, criterio: "Los faltantes o sobrantes están identificados, justificados y reportados oportunamente." },
      { n: 7, criterio: "Los arqueos, reportes y soportes no presentan alteraciones o correcciones no autorizadas." },
      { n: 8, criterio: "Los cambios de turno incluyen conteo y entrega de efectivo y demás medios de pago." }
    ]
  },
  {
    nombre: "C. Medios de pago",
    items: [
      { n: 9, criterio: "Los pagos con tarjeta coinciden con cierres de datáfono y reportes del sistema." },
      { n: 10, criterio: "Las transferencias están plenamente identificadas, son legibles y corresponden al valor de la compra." },
      { n: 11, criterio: "Bonos u otros medios autorizados cuentan con soportes completos y están correctamente registrados." },
      { n: 12, criterio: "Las transacciones rechazadas, duplicadas o con novedad tienen tratamiento y soporte correspondiente." }
    ]
  },
  {
    nombre: "D. Devoluciones, anulaciones y cruces",
    items: [
      { n: 13, criterio: "Las devoluciones cumplen el procedimiento y cuentan con factura, motivo, datos y autorización requeridos." },
      { n: 14, criterio: "Las anulaciones están justificadas y cuentan con autorización y trazabilidad en el sistema." },
      { n: 15, criterio: "Las transferencias duplicadas cuentan con Formato de Buena Fe y requisición de devolución cuando aplica." },
      { n: 16, criterio: "Los cruces de dinero están soportados y corresponden al valor, factura y medio de pago correctos." }
    ]
  },
  {
    nombre: "E. Cierres y soportes de Tesorería",
    items: [
      { n: 17, criterio: "Se realizan cierres parciales y finales verificando efectivo y todos los medios de pago." },
      { n: 18, criterio: "El efectivo entregado está contado, organizado y relacionado con el cierre de caja." },
      { n: 19, criterio: "Los vouchers de tarjetas están enumerados y totalizados." },
      { n: 20, criterio: "El cierre detallado de datáfono está anexado y las diferencias están justificadas." },
      { n: 21, criterio: "Bonos, transferencias, devoluciones y demás soportes están organizados junto con el arqueo final." },
      { n: 22, criterio: "Los soportes enviados a Tesorería están completos, legibles, organizados y debidamente justificados." }
    ]
  },
  {
    nombre: "F. Cumplimiento de cajeros y coordinación",
    items: [
      { n: 23, criterio: "Los cajeros aplican correctamente los procedimientos de caja, facturación y medios de pago." },
      { n: 24, criterio: "El Coordinador Administrativo supervisa bases, arqueos, cambios de turno y cierres conforme al procedimiento." },
      { n: 25, criterio: "Se documentan y reportan hallazgos, novedades e inconsistencias al nivel correspondiente." },
      { n: 26, criterio: "Se mantiene confidencialidad y custodia adecuada de dinero, información financiera y soportes." }
    ]
  },
  {
    nombre: "G. Seguimiento a auditorías",
    items: [
      { n: 27, criterio: "Los hallazgos de auditorías anteriores cuentan con plan de acción y responsable definido." },
      { n: 28, criterio: "Las acciones correctivas vencidas han sido cerradas con evidencia suficiente." },
      { n: 29, criterio: "Los hallazgos recurrentes se encuentran escalados y tienen seguimiento documentado." },
      { n: 30, criterio: "La evidencia de la auditoría queda organizada y disponible para consulta y trazabilidad." }
    ]
  }
];

export default function HistorialAuditoriaTesoreria({ usuario, permisosABAC, onBack }) {
  const [busqueda, setBusqueda] = useState("");
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [auditoriaSeleccionada, setAuditoriaSeleccionada] = useState(null);

  useEffect(() => {
    const fetchHistorial = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auditoria-tesoreria`);
        const data = await res.json();
        if (data.success) {
          const cargoUpper = String(usuario?.cargo || "").toUpperCase();
          const esAdminGlobal = cargoUpper === "SUPER_ADMIN";
          
          let filtrados = data.registros;
          if (!esAdminGlobal) {
            filtrados = data.registros.filter(r => String(r.codigo_bodega) === String(usuario?.codigo_bodega || usuario?.sede_id));
          }
          setRegistros(filtrados);
        }
      } catch (error) {
        console.error("Error cargando historial de tesorería:", error);
      } finally {
        setCargando(false);
      }
    };
    fetchHistorial();
  }, [usuario]);

  const registrosFiltrados = registros.filter(r => 
    (r.sede || "").toLowerCase().includes(busqueda.toLowerCase()) || 
    (r.auditor || "").toLowerCase().includes(busqueda.toLowerCase())
  );

  // Parsear de forma segura el detalle de respuestas guardado en BD
  const parsearDetalle = (detalleRaw) => {
    if (!detalleRaw) return {};
    if (typeof detalleRaw === 'object') return detalleRaw;
    try {
      return JSON.parse(detalleRaw);
    } catch (e) {
      return {};
    }
  };

  return (
    <div className="w-full min-h-screen py-6 px-4 flex flex-col items-center animate-fade-in relative z-10">
      
      {/* MODAL DE DETALLE AMPLIADO (Incluye desglose pregunta por pregunta y firmas) */}
      {auditoriaSeleccionada && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-md p-4 animate-fade-in">
          <div className="bg-white/90 backdrop-blur-3xl rounded-[32px] p-6 sm:p-8 shadow-2xl w-full max-w-4xl border border-white text-left animate-scale-in flex flex-col max-h-[92vh]">
            
            <div className="flex justify-between items-center border-b border-gray-200 pb-4 mb-4 shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-xl shadow-sm border border-purple-200">🗂️</div>
                <div>
                  <h3 className="text-lg font-black text-gray-900 tracking-tight">Detalle Completo de Auditoría</h3>
                  <p className="text-[10px] text-gray-500 font-bold uppercase">ID: #{auditoriaSeleccionada.id} | Código Sede: {auditoriaSeleccionada.codigo_bodega}</p>
                </div>
              </div>
              <button onClick={() => setAuditoriaSeleccionada(null)} className="w-8 h-8 bg-gray-100 hover:bg-red-100 hover:text-red-600 rounded-full flex items-center justify-center text-gray-600 font-bold transition-colors cursor-pointer shadow-sm">✕</button>
            </div>
            
            <div className="overflow-y-auto custom-scrollbar pr-2 space-y-6 text-sm text-gray-700">
              
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-white/80 p-3.5 rounded-2xl border border-gray-100 shadow-sm">
                  <p className="text-[10px] font-black text-gray-500 uppercase tracking-wide">Sede / PDV</p>
                  <p className="font-extrabold text-gray-900 truncate">{auditoriaSeleccionada.sede || `Cód: ${auditoriaSeleccionada.codigo_bodega}`}</p>
                </div>
                <div className="bg-white/80 p-3.5 rounded-2xl border border-gray-100 shadow-sm">
                  <p className="text-[10px] font-black text-gray-500 uppercase tracking-wide">Fecha y Hora</p>
                  <p className="font-extrabold text-gray-900">{auditoriaSeleccionada.fecha} <span className="text-xs font-normal text-gray-500">({auditoriaSeleccionada.hora_auditoria})</span></p>
                </div>
                <div className="bg-white/80 p-3.5 rounded-2xl border border-gray-100 shadow-sm">
                  <p className="text-[10px] font-black text-gray-500 uppercase tracking-wide">Auditor Responsable</p>
                  <p className="font-extrabold text-gray-900">{auditoriaSeleccionada.auditor}</p>
                </div>
              </div>

              <div className="flex justify-between items-center bg-slate-900 p-5 rounded-2xl text-white shadow-inner">
                <div>
                  <p className="text-[10px] text-gray-400 font-black uppercase tracking-wider mb-1">Estado Final</p>
                  <p className={`text-xs font-black uppercase px-2.5 py-1 rounded-md border inline-block ${auditoriaSeleccionada.estado === 'CERRADO' ? 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' : 'bg-amber-500/20 text-amber-400 border-amber-500/30'}`}>
                    {auditoriaSeleccionada.estado}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-[10px] text-gray-400 font-black uppercase tracking-wider mb-1">Puntaje Obtenido</p>
                  <p className={`text-3xl font-black ${auditoriaSeleccionada.puntaje >= 80 ? 'text-emerald-400' : 'text-red-400'}`}>
                    {auditoriaSeleccionada.puntaje}%
                  </p>
                </div>
              </div>

              <div className="bg-white/80 p-4 rounded-2xl border border-gray-100 shadow-sm">
                <p className="text-[10px] font-black text-blue-600 uppercase tracking-wide mb-2">Información General y Observaciones</p>
                <div className="bg-blue-50/50 p-3 rounded-xl border border-blue-100/50">
                  <p className="font-medium text-gray-800 text-[11px] whitespace-pre-wrap leading-relaxed">{auditoriaSeleccionada.observaciones || "Sin observaciones adicionales."}</p>
                </div>
              </div>

              {/* DESGLOSE PREGUNTA POR PREGUNTA */}
              <div className="space-y-4">
                <h4 className="text-xs font-black uppercase tracking-wider text-gray-900 border-l-4 border-purple-600 pl-2">Desglose de Resultados por Componente</h4>
                
                {(() => {
                  const respuestasObj = parsearDetalle(auditoriaSeleccionada.respuestas_detalle || auditoriaSeleccionada.respuestas);
                  
                  return COMPONENTES_AUDITORIA.map((comp, idx) => (
                    <div key={idx} className="bg-white/70 border border-gray-200/80 rounded-2xl overflow-hidden shadow-sm">
                      <div className="bg-gray-900 text-white px-4 py-2.5 text-xs font-extrabold uppercase tracking-wide">
                        {comp.nombre}
                      </div>
                      <div className="divide-y divide-gray-200">
                        {comp.items.map((item) => {
                          const resItem = respuestasObj[item.n] || {};
                          const resultado = resItem.resultado || "N/A";
                          
                          let badgeColor = "bg-gray-100 text-gray-700 border-gray-300";
                          if (resultado === "CUMPLE") badgeColor = "bg-emerald-100 text-emerald-800 border-emerald-300";
                          if (resultado === "NO CUMPLE") badgeColor = "bg-red-100 text-red-800 border-red-300";

                          return (
                            <div key={item.n} className="p-3.5 text-xs flex flex-col gap-1.5 hover:bg-white transition-colors">
                              <div className="flex justify-between items-start gap-3">
                                <span className="font-bold text-gray-800"><strong className="text-purple-700">#{item.n}</strong> {item.criterio}</span>
                                <span className={`px-2 py-0.5 rounded text-[9px] font-black uppercase border shrink-0 ${badgeColor}`}>
                                  {resultado}
                                </span>
                              </div>
                              {resItem.observacion && (
                                <p className="text-[11px] text-gray-600 pl-5">💡 <em>Observación:</em> {resItem.observacion}</p>
                              )}
                              {resultado === "NO CUMPLE" && (
                                <div className="flex flex-wrap gap-3 pl-5 text-[10px] font-bold text-red-700">
                                  {resItem.riesgo && <span className="bg-red-50 border border-red-200 px-2 py-0.5 rounded">Riesgo: {resItem.riesgo}</span>}
                                  {resItem.responsable && <span className="bg-red-50 border border-red-200 px-2 py-0.5 rounded">Responsable: {resItem.responsable}</span>}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ));
                })()}
              </div>

              {/*VISUALIZACIÓN DE FIRMAS */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                <div className="bg-white/80 p-4 rounded-2xl border border-gray-100 shadow-sm text-center">
                  <p className="text-[10px] font-black text-gray-500 uppercase tracking-wide mb-2">Firma del Auditor</p>
                  {auditoriaSeleccionada.firma_auditor ? (
                    <img src={auditoriaSeleccionada.firma_auditor} alt="Firma Auditor" className="max-h-24 mx-auto border border-gray-200 rounded-xl bg-white p-1 shadow-inner" />
                  ) : (
                    <p className="text-xs text-gray-400 italic">No registrada</p>
                  )}
                  <p className="text-[11px] font-extrabold text-gray-900 mt-2 uppercase">{auditoriaSeleccionada.auditor}</p>
                </div>

                <div className="bg-white/80 p-4 rounded-2xl border border-gray-100 shadow-sm text-center">
                  <p className="text-[10px] font-black text-gray-500 uppercase tracking-wide mb-2">Firma Admin. de Punto</p>
                  {auditoriaSeleccionada.firma_admin ? (
                    <img src={auditoriaSeleccionada.firma_admin} alt="Firma Admin" className="max-h-24 mx-auto border border-gray-200 rounded-xl bg-white p-1 shadow-inner" />
                  ) : (
                    <p className="text-xs text-gray-400 italic">No registrada</p>
                  )}
                  <p className="text-[11px] font-extrabold text-gray-900 mt-2 uppercase">Administrador de Punto</p>
                </div>
              </div>

            </div>

            <div className="mt-6 pt-4 border-t border-gray-200 shrink-0">
               <button onClick={() => setAuditoriaSeleccionada(null)} className="w-full py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold text-xs uppercase tracking-wider rounded-xl transition-colors cursor-pointer">Cerrar Detalle</button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white/50 backdrop-blur-[45px] rounded-[34px] shadow-[0_25px_70px_rgba(0,0,0,0.15)] p-4 sm:p-8 max-w-7xl w-full mx-auto h-[90vh] overflow-hidden border border-white/80 flex flex-col text-gray-900">
        
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-900/10 pb-4 mb-6 gap-4 shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-purple-100 border border-purple-200 flex items-center justify-center text-2xl shadow-inner text-purple-700">🗂️</div>
            <div>
              <h2 className="text-lg sm:text-xl font-black tracking-tight text-gray-900 leading-tight">Historial de Auditorías</h2>
              <p className="text-[10px] sm:text-xs font-bold text-gray-600 mt-0.5">Reportes y trazabilidad de Tesorería</p>
            </div>
          </div>
          <div className="w-full sm:w-auto flex items-center gap-3">
            <div className="relative w-full sm:w-64">
              <input 
                type="text" placeholder="Buscar por sede o auditor..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)}
                className="w-full px-4 py-2.5 bg-white/70 border border-white/90 rounded-full text-xs font-bold focus:outline-none focus:border-purple-400 shadow-inner pl-9 transition-colors"
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">🔍</span>
            </div>
            <button onClick={onBack} className="px-5 py-2.5 rounded-full bg-white/60 hover:bg-white text-gray-800 text-xs font-bold transition-all border border-gray-200 shadow-sm shrink-0 cursor-pointer">
              Cerrar
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar pr-2">
          {cargando ? (
             <div className="text-center py-20 text-gray-500 font-bold animate-pulse">Cargando registros...</div>
          ) : registrosFiltrados.length === 0 ? (
             <div className="text-center py-20 bg-white/40 rounded-2xl border border-dashed border-gray-300">
               <span className="text-5xl block mb-4 opacity-50">📂</span>
               <p className="text-gray-600 font-bold">No hay registros de auditoría en este momento.</p>
             </div>
          ) : (
            <div className="bg-white/40 rounded-2xl border border-white/70 shadow-inner overflow-hidden">
              <table className="w-full text-left text-[11px] text-gray-800">
                <thead className="bg-white/80 text-gray-900 font-extrabold sticky top-0 border-b border-gray-200 shadow-sm">
                  <tr>
                    <th className="p-4">ID Auditoría</th>
                    <th className="p-4">Fecha</th>
                    <th className="p-4">Sede / PDV</th>
                    <th className="p-4">Auditor</th>
                    <th className="p-4 text-center">Puntaje</th>
                    <th className="p-4 text-center">Estado</th>
                    <th className="p-4 text-right">Acción</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200/50">
                  {registrosFiltrados.map(reg => (
                    <tr key={reg.id} className="hover:bg-white/60 transition-colors">
                      <td className="p-4 font-black text-gray-900">#{reg.id}</td>
                      <td className="p-4 font-semibold text-gray-600">{reg.fecha} <span className="text-[9px] block text-gray-400">{reg.hora_auditoria}</span></td>
                      <td className="p-4 font-bold text-gray-800">{reg.sede || `Cód: ${reg.codigo_bodega}`}</td>
                      <td className="p-4 font-medium text-gray-700">{reg.auditor}</td>
                      <td className="p-4 text-center">
                        <span className={`px-2.5 py-1 rounded-md font-black border ${reg.puntaje >= 80 ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                          {reg.puntaje}%
                        </span>
                      </td>
                      <td className="p-4 text-center">
                        <span className={`px-2 py-0.5 rounded-full text-[9px] font-black border uppercase tracking-wider ${reg.estado === 'CERRADO' ? 'bg-blue-100 text-blue-700 border-blue-200' : 'bg-amber-100 text-amber-700 border-amber-200'}`}>
                          {reg.estado}
                        </span>
                      </td>
                      <td className="p-4 text-right">
                        <button 
                          onClick={() => setAuditoriaSeleccionada(reg)} 
                          className="px-4 py-1.5 bg-white border border-gray-200 hover:border-purple-300 text-purple-700 text-[10px] font-bold rounded-lg shadow-sm transition-all cursor-pointer"
                        >
                          Ver Detalle
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}